import React, { useEffect } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import Section from 'components/common/Section';
import SectionHeader from './SectionHeader';
import { useTranslation } from 'react-i18next';

const LandingFaq = () => {
  const { t, i18n } = useTranslation();
  const faqItems = t('LANDING.FAQ_ITEMS', { returnObjects: true });

  useEffect(() => {
    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map(item => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.a
        }
      }))
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    script.id = 'faq-jsonld';
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('faq-jsonld');
      if (existing) existing.remove();
    };
  }, [i18n.language]);

  return (
    <Section bg="light" id="faq">
      <SectionHeader
        title={t('LANDING.FAQ_TITLE')}
        subtitle={t('LANDING.FAQ_SUBTITLE')}
      />
      <Card className="mt-5 shadow-sm border-0">
        <Card.Body>
          <Accordion className="border rounded overflow-hidden">
            {faqItems.map((item, index) => (
              <Accordion.Item
                key={index}
                eventKey={String(index)}
                className="border-start-0 border-end-0 border-top-0"
              >
                <Accordion.Header>
                  <span className="fw-medium font-sans-serif text-900">
                    {item.q}
                  </span>
                </Accordion.Header>
                <Accordion.Body className="text-700">
                  {item.a}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Card.Body>
      </Card>
    </Section>
  );
};

export default LandingFaq;
